import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, createVNode as _createVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "time-header" }

import labels from "../../shared/labels";
import CountdownTime from "./countdown-time.vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'countdown',
  props: {
    timeIsNotStarted: Boolean,
    secondsLeft: {
        type: Number,
        required: true,
    },
    blank: Boolean,
},
  setup(__props) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass({
            'time-container': true,
            'under-4-hours': __props.secondsLeft < 14400,
        })
  }, [
    _createElementVNode("span", _hoisted_1, [
      _renderSlot(_ctx.$slots, "header", {}, () => [
        _createTextVNode(_toDisplayString(__props.timeIsNotStarted
                    ? _unref(labels).frontendProductList.productSpecs.headers
                          .timeLeftToStart
                    : _unref(labels).frontendProductList.productSpecs.headers.timeLeft), 1 /* TEXT */)
      ])
    ]),
    _createVNode(CountdownTime, {
      "seconds-left": __props.secondsLeft,
      blank: __props.blank
    }, null, 8 /* PROPS */, ["seconds-left", "blank"])
  ], 2 /* CLASS */))
}
}

})